import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-12 text-center">
          <div className="text-blue-600 mb-4">
            <Loader2 size={64} className="mx-auto animate-spin" />
          </div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">Carregando dados...</h3>
          <p className="text-gray-600">
            Aguarde enquanto buscamos os dados mais recentes
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;